import { render, staticRenderFns } from "./MenuButtonColumn.vue?vue&type=template&id=3bf46971&scoped=true&"
import script from "./MenuButtonColumn.vue?vue&type=script&lang=js&"
export * from "./MenuButtonColumn.vue?vue&type=script&lang=js&"
import style0 from "./MenuButtonColumn.vue?vue&type=style&index=0&id=3bf46971&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf46971",
  null
  
)

export default component.exports